/**
 * @generated SignedSource<<1c36cae8100639d7f124ddf7cf51e472>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegateFromListRowFragment" | "DelegateProfileImageFragment" | "DelegatedToListRowFragment" | "ForAgainstAbstainRowFragment" | "NameSectionFragment" | "ProposalsCreatedRowFragment" | "ProposalsVotedRowFragment" | "RecentActivityRowFragment" | "TotalVotePowerRowFragment" | "VotePowerRowFragment" | "VoterPanelActionsFragment">;
  readonly " $fragmentType": "VoterPanelFragment";
};
export type VoterPanelFragment$key = {
  readonly " $data"?: VoterPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NameSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalsCreatedRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecentActivityRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DelegateFromListRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DelegatedToListRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TotalVotePowerRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForAgainstAbstainRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VotePowerRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalsVotedRowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DelegateProfileImageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoterPanelActionsFragment"
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "5cda5cf3fb9978de0119b7c288bbfe48";

export default node;
